import React from 'react';
import { Register } from '../factory';
import DySelectMultiple from './dy-select-multiple';

@Register({ name: 'dy-checkbox' })
class DyCheckbox extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleToggleOption = option => {
        const { onChange, value } = this.props;

        let valueArray = value || [];
        let idx = valueArray.indexOf(option);

        if (~idx) {
            valueArray.splice(idx, 1);
        } else {
            valueArray.push(option);
        }

        onChange && onChange(valueArray);
    };

    render() {
        let { className, name, options, value, selectType } = this.props;
        if(!!selectType) {
            return <DySelectMultiple {...this.props}/>
        }
        if (!options) {
            return '';
        }
        let valueArray = value || [];
        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                {options.map(option => (
                    <div
                        className={`dy-fm-item-checkbox ${!!~valueArray.indexOf(Number(option.seq)) ? 'checked' : ''}`}
                        key={option.content}
                    >
                        <label className="dy-fm-item-checkbox-ct">
                            <input type="checkbox" name={name} onClick={() => this.handleToggleOption(Number(option.seq))} />
                            <span className="dy-fm-item-icon"></span>
                            {option.content}
                        </label>
                    </div>
                ))}
            </div>
        );
    }
}

export default DyCheckbox;
